import firebase from 'firebase/app';

//blueprint
import { Position,  Intent, Toaster } from "@blueprintjs/core";

const AppToaster = Toaster.create({
    className: "deleted-content",
    position: Position.TOP,
});

const showToast = () => {
    AppToaster.show({ message: "Message is deleted", intent: Intent.DANGER, timeout: 1000});
}

export const deleteLikedMsg = (id, profile) =>{
            firebase
            .firestore()
            .collection('likedContent')
            .doc(id)
            .delete()
            .then(()=>{
                showToast();
            })
}

export const deleteMsg = (id, profile) =>{
    firebase
        .firestore()
        .collection('organizations')
        .doc(profile.company)
        .collection('prospects')
        .doc(id)
        .delete()
        .then(()=>{
            showToast();
        })
}